// Tiny external store for per-path SEO overrides. Lives outside React so the
// lint rule that disallows setState inside useEffect doesn't fire.
//
// Each path entry is one of:
//   undefined → never fetched
//   "pending" → fetch in flight (avoid duplicate requests)
//   object    → fetched payload (possibly empty {})
//
// Subscribers re-render whenever any path's entry changes.

import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const store = new Map();
const subs = new Set();
const EMPTY = Object.freeze({});

function notify() {
  for (const cb of subs) cb();
}

export function subscribePageSeo(cb) {
  subs.add(cb);
  return () => subs.delete(cb);
}

export function getPageSeoSnapshot(path) {
  if (!path) return EMPTY;
  const entry = store.get(path);
  if (entry && typeof entry === "object") return entry;
  return EMPTY;
}

export function loadPageSeo(path) {
  if (!path) return;
  const existing = store.get(path);
  if (existing !== undefined) return; // already cached or pending

  store.set(path, "pending");
  axios
    .get(`${API}/page-seo`, { params: { path } })
    .then((res) => {
      const payload = res?.data && typeof res.data === "object" ? res.data : {};
      store.set(path, payload);
      notify();
    })
    .catch(() => {
      store.set(path, {});
      notify();
    });
}
